<template>
  <div class="atomic-action-notice">
    <div class="atomic-action-notice__title">
      {{ title }}
    </div>
    <div class="atomic-action-notice__desc">
      {{ description }}
    </div>
    <button-base class="atomic-action-notice__btn" type="primary" @click="emit('click-action')">
      {{ btnTxt }}
    </button-base>
  </div>
</template>
<script setup lang="ts">
  defineProps<{
    title: string;
    description: string;
    btnTxt: string;
  }>();
  const emit = defineEmits(['click-action']);
</script>

<style src="~/assets/styles/components/atomic/action-notice.scss" lang="scss" />
